export const ProfileVisibility = {
  Public: 'public',
  Private: 'private',
} as const;
export type ProfileVisibility = (typeof ProfileVisibility)[keyof typeof ProfileVisibility];

export const JobSearchStatus = {
  ActivelyLooking: 'actively_looking',
  OpenToOffers: 'open_to_offers',
  NotLooking: 'not_looking',
} as const;
export type JobSearchStatus = (typeof JobSearchStatus)[keyof typeof JobSearchStatus];

export const MatchingStatus = {
  Active: 'active',
  Paused: 'paused',
} as const;
export type MatchingStatus = (typeof MatchingStatus)[keyof typeof MatchingStatus];
